import React, { useState, useRef } from "react";

const PinInputCustom = ({ length = 6, onChange, onComplete, isMobile = false }) => {
    const [values, setValues] = useState(Array(length).fill(""));
    const inputRefs = useRef([]);

    const handleChange = (index, value) => {
        if (value && !/^\d$/.test(value)) {
            return;
        }

        const newValues = [...values];
        newValues[index] = value;

        setValues(newValues);

        const pinValue = newValues.join("");

        if (onChange) {
            onChange(pinValue);
        }

        if (value && index < length - 1) {
            inputRefs.current[index + 1].focus();
        }

        if (onComplete && newValues.every((v) => v !== "")) {
            onComplete(newValues.join(""));
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newValues = [...values];

            if (values[index]) {
                newValues[index] = "";
                setValues(newValues);

                if (onChange) {
                    onChange(newValues.join(""));
                }
            } else if (index > 0) {
                newValues[index - 1] = "";
                setValues(newValues);
                inputRefs.current[index - 1].focus();

                if (onChange) {
                    onChange(newValues.join(""));
                }
            }
        }

        if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1].focus();
        }

        if (e.key === "ArrowRight" && index < length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();

        const pasteData = e.clipboardData.getData("text");
        const pasteValues = pasteData
            .replace(/\D/g, "")
            .slice(0, length)
            .split("");

        const newValues = [...values];

        pasteValues.forEach((value, index) => {
            if (index < length) {
                newValues[index] = value;
            }
        });

        setValues(newValues);

        if (onChange) {
            onChange(newValues.join(""));
        }

        const nextEmptyIndex = newValues.findIndex((v) => v === "");

        const focusIndex = nextEmptyIndex === -1 ? length - 1 : nextEmptyIndex;

        inputRefs.current[focusIndex].focus();

        if (onComplete && newValues.every((v) => v !== "")) {
            onComplete(newValues.join(""));
        }
    };

    const handleFocus = (index) => {
        if (inputRefs.current[index]) {
            inputRefs.current[index].select();
        }
    };

    return (
        <div className="pin-input-custom-container">
            {values.map((value, index) => (
                <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    className="pin-input-custom"
                    value={value}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    onFocus={() => handleFocus(index)}
                    placeholder="0"
                    style={{
                        border: value ? "1px solid #003011" : "1px solid #E4E4E4",
                        color: value ? "#003011" : "#999999",
                        fontWeight: value ? "600" : "400",
                    }}
                />
            ))}
        </div>
    );
};

export default PinInputCustom;
